import { render, staticRenderFns } from "./FileButton.vue?vue&type=template&id=7d516844&scoped=true"
import script from "./FileButton.vue?vue&type=script&lang=js"
export * from "./FileButton.vue?vue&type=script&lang=js"
import style0 from "./FileButton.vue?vue&type=style&index=0&id=7d516844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d516844",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
